import { FlexRow, MaterialIcon } from '@gorila-shared-ui/components';
import { LabelXSmall } from 'baseui/typography';
import moment from 'moment';
import { memo } from 'react';
import { useRecoilValue } from 'recoil';
import { useStyles } from '../../hooks/useStyles';
import { updatedCurrentStateState } from '../../storage/client';

type Props = {
  timestamp: string;
};

function CurrentStateReport({ timestamp }: Readonly<Props>) {
  const { theme, css } = useStyles();
  // Triggers re evaluation of last report time
  useRecoilValue(updatedCurrentStateState);
  const lastReportTime = moment(+timestamp).fromNow();

  return (
    <FlexRow
      centered
      gap={theme.sizing.scale100}
    >
      <span className={css({ transform: 'rotateY(180deg)', lineHeight: 0 })}>
        <MaterialIcon
          name="refresh"
          color={theme.colors.contentTertiary}
          size="18px"
        />
      </span>
      <LabelXSmall
        color={theme.colors.contentTertiary}
        margin={0}
      >
        Último reporte: {lastReportTime}
      </LabelXSmall>
    </FlexRow>
  );
}

export default memo(CurrentStateReport);
